import { ca } from '@cian/analytics';

import { type PikHistoryItemsService } from 'shared/services/ChipsDataService';
import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: блок «История компании» попал в зону видимости.
 */
export function trackShowPikHistorySection(pikHistoryItemsService: PikHistoryItemsService): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'pik_history',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: pikHistoryItemsService.items.map((item, index) => ({
            id: item.chipsOption.value,
            offerType: 'year',
            position: index,
          })),
        },
      }),
    ],
  });
}
